import isObject from 'lodash/isObject'
import identity from 'lodash/identity'

/**
 *
 * @param {{}} obj
 * @param {function} cb
 * @returns {{}}
 */
const stringifyErrorAndProcessObject = cb => object => {
  if (object instanceof Error) {
    return object.toString()
  }
  return cb(object)
}

/**
 * @param {{}} object
 * @returns {{}}
 */
const stringifyObjectValues = object => Object.entries(object).reduce((acc, [attrName, attrValue]) => {
  acc[attrName] = isObject(attrValue) ? '[object]' : attrValue

  return acc
}, {})

/**
 * @param {{}} object
 * @returns {{}}
 * @throws {TypeError}
 */
function ignoreSecondLevelOfNestingObject (object) {
  if (!isObject(object)) {
    throw new TypeError('object should be an object')
  }

  return Object.entries(object).reduce((acc, [attrName, attrValue]) => {
    const valueTransformer = isObject(attrValue)
      ? stringifyErrorAndProcessObject(stringifyObjectValues)
      : identity

    acc[attrName] = valueTransformer(attrValue)

    return acc
  }, {})
}

/**
 * @param {{}} object
 * @returns {{}}
 * @throws {TypeError}
 */
export default function ignoreThirdLevelOfNestingObject (object) {
  if (!isObject(object)) {
    throw new TypeError('object should be an object')
  }

  return Object.entries(object).reduce((acc, [attrName, attrValue]) => {
    const valueTransformer = isObject(attrValue)
      ? stringifyErrorAndProcessObject(ignoreSecondLevelOfNestingObject)
      : identity

    acc[attrName] = valueTransformer(attrValue)

    return acc
  }, {})
}



// WEBPACK FOOTER //
// ./src/utils/Logger/ignoreThirdLevelOfNestingObject.js